
import "./CreateClient.css";
import React, { useEffect, useState } from "react";
import StarRateIcon from "@mui/icons-material/StarRate";

type propsData = {
    accountManager: string,
    firstName: string,
    lastName: string,
    brokerageName:string,
    clientMainName: boolean,
    companyName: string,
    setAccountManager: (newAccountManager: string) => void,
    setFirstName: (newFirstName: string) => void,
    setLastName: (newLastName: string) => void,
    setBrokerageName: (newBrokerageName: string) => void,
    setClientMainName: (newClientMainName: boolean) => void,
    setCompanyName: (newCompanyName: string) => void,
    invalidInfoAlert: boolean,
}

function PersonalData(props: propsData ) {

    const {
        firstName,
        lastName,
        accountManager,
        brokerageName,
        clientMainName,
        companyName,
        setCompanyName,
        setClientMainName,
        setAccountManager,
        setFirstName,
        setLastName,
        setBrokerageName,
        invalidInfoAlert
    } = props;

    const [errorFirstName, setErrorFirstName] = useState<boolean>(false);
    const [errorLastName, setErrorLastName] = useState<boolean>(false);

    useEffect(() => {
        if (invalidInfoAlert) {
            if (firstName.length === 0) setErrorFirstName(true);
            else setErrorFirstName(false);
            if (lastName.length ===0) setErrorLastName(true);
            else setErrorLastName(false);
        }
        else {
            setErrorFirstName(false);
            setErrorLastName(false);
        }
    }, [invalidInfoAlert])

    return(
        <div className="PersonalData">
            <div className="createClient-form-type">
                <div className="form-type-box">
                    <label> Account Manager </label>
                </div>
                <div className = "form-type-box">
                    <input
                        className = "type-box-type-input"
                        type = "text"
                        value = { accountManager }
                        onChange = {e => setAccountManager(e.target.value)}
                    />
                </div>
            </div>
            <div className="createClient-form-name">
                <div className="form-fullName-Box">
                    <div className="form-name-box">
                        <label className="required">
                            First Name
                            <StarRateIcon style = {{ color: "red", fontSize: "10px" }}/>
                        </label>
                        <div className="form-name-box-option">
                            <input
                                type = "text"
                                className = "form-input-Name"
                                style = {{
                                    width: "390px",
                                    border: errorFirstName ? "1px solid red" : "1px solid #ccc"
                                }}
                                value = { firstName }
                                onChange = { e => setFirstName(e.target.value) }
                            />
                        </div>
                    </div>
                    <div className="form-name-box">
                        <label className="required">Last Name <StarRateIcon style = {{ color: "red", fontSize: "10px" }}/></label>
                        <div className="form-name-box-option">
                            <input
                                type = "text"
                                style = {{
                                    width: "390px",
                                    border: errorLastName ? "1px solid red" : "1px solid #ccc"
                                }}
                                className = "form-input-Name"
                                value = { lastName }
                                onChange = {e => setLastName(e.target.value)}
                            />
                            <input
                                type = "radio"
                                id = "fullNameOption"
                                name = "nameOption"
                                style = {{
                                    width: "20px",
                                    height: "20px",
                                }}
                                checked = { clientMainName }
                                onClick = {() => {
                                    setClientMainName(true)
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="form-name-box">
                    <label>Marketing Name</label>
                    <div className="form-name-box-option">
                        <input
                            type = "text"
                            value = { companyName }
                            onChange = { e => setCompanyName(e.target.value) }
                        />
                        <input
                            type = "radio"
                            style = {{
                                width: "20px",
                                height: "20px"
                            }}
                            checked = { !clientMainName }
                            id = "companyNameOption"
                            name = "nameOption"
                            onClick = {e => {
                                setClientMainName(false);
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="createClient-form-type">
                <div className="form-type-box">
                    <label> Brokerage Name </label>
                </div>
                <div className="form-type-box mrg-btm">
                    <input
                        className = "type-box-type-input"
                        type = "text"
                        value = { brokerageName }
                        onChange = { e => setBrokerageName(e.target.value) }
                    />
                </div>
            </div>
        </div>
    )
}

export default PersonalData;
